
<div style="position: relative; height: 100%;">
  <ng-container dynamicComponent></ng-container>   
</div>